<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="selectedUrl ? `crud/${inputs.id}` : `crud`"
        >
          <div class="row align-items-center">
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_email" >
               {{ $t("Costumer") }}
              </label>
              <app-input
                type="search-select"
                :list="this.costumers"
                :isAnimatedDropdown="true"
                :required="true"
                :placeholder="$t('select_customer')"
                v-model="inputs.costumer"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_name">
                {{ $t("service_name") }}
              </label>
              <app-input
                type="text"
                :required="true"
                :placeholder="$t('service_name')"
                v-model="inputs.service.name"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_quantity">
                {{ $t("service_quantity") }}
              </label>
              <app-input
                type="number"
                :required="true"
                :placeholder="$t('service_quantity')"
                v-model="inputs.service.quantity"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_email">
                {{ $t("amount") }}
              </label>
              <app-input
                type="number"
                :required="true"
                :placeholder="$t('amount')"
                v-model="inputs.amount"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_email">
                {{ $t("paid_amount") }}
              </label>
              <app-input
                type="number"
                :required="true"
                :placeholder="$t('paid_amount')"
                v-model="inputs.paid_amount"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_vat">
                {{ $t("service_vat") }}
              </label>
              <app-input
                type="number"
                :required="true"
                :placeholder="$t('service_vat')"
                v-model="inputs.service.vat"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label>{{ $t("due_date") }}</label>
              <app-input
                type="date"
                v-model="inputs.due_date"
                :placeholder="$t('select_valid_date')"
              />
            </div>
            <div class="col-sm-6 mb-2 form-group">
              <label for="inputs_email">
                {{ $t("status") }}
              </label>
              <app-input
                type="select"
                :list="this.status"
                :required="true"
                :isAnimatedDropdown="true"
                v-model="inputs.status"
              />
            </div>
            <div class="col-sm-12 mb-2 form-group">
              <label for="inputs_editor">
                {{ $t("note") }}
              </label>
              <app-input
                type="text-editor"
                :required="true"
                id="note"
                :label="$t('message_placeholder')"
                v-model="inputs.note"
              />
            </div>
          </div>
          <!-- <div class="form-group row align-items-center">
            <label for="inputs_email" class="col-sm-3 mb-0">
              {{ $t("amount") }}
            </label>
            <app-input
              id="amount"
              class="col-sm-9"
              type="number"
              v-model="inputs.amount"
              :required="true"
            />
          </div> -->
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../../app/Mixins/ModalMixin";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../../Helpers/AppLibrary";
import {
  INVOICE_PACKAGE_LIST,
  CUSTOMERS_LIST,
  CUSTOMER_INVOICE_STORE,
} from "../../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      preloader: false,
      required: false,
      inputs: {
        paid_amount: 0,
        due_date: new Date(),
        service: {},
      },
      costumers: [],
      packages: [],
      status: [
        { id: "", value: "Select Amount Status" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Overdue" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      this.preloader = true;
      if (this.inputs.due_date) this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
      axiosPost(CUSTOMER_INVOICE_STORE, this.inputs)
        .then((res) => {
          
          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          
          this.$toastr.e(error);
        })
        .finally(() => {
          this.preloader = false;
          $("#demo-add-edit-Modal").modal("hide");
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getcompany() {
      axiosGet(CUSTOMERS_LIST)
        .then((response) => {
          
          this.costumers = response.data;
        })
        .catch((error) => {
          
        });
    },
    getPackages() {
      axiosGet(INVOICE_PACKAGE_LIST)
        .then((response) => {
          
          this.packages = response.data;
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getcompany();
    this.getPackages();
    // this.getPackageInfo();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
